import { Box, Flex, Grid as ChakraGrid } from '@chakra-ui/react';
import { Button, Grid } from '@time-line/components/common';
import { ArrowRight } from '@time-line/components/icons';
import { useInView } from 'react-intersection-observer';

import { Cells } from './Cells';
import { Chart } from './Chart';
import data from './data.json';
import { Multiplier } from './Multiplier';
import { Problem } from './Problem';
import { Solution } from './Solution';

export const MitopureElaborationMobile = () => {
  const { ref: cellsRef, inView: cellsInView } = useInView({
    threshold: 0.5,
  });

  const { ref: chartRef, inView: chartInView } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  return (
    <Box className="mitopure-elaboration--mobile">
      <Box>
        <Grid pt="2xl">
          <Box gridColumn="main">
            <Problem.Title />
          </Box>
        </Grid>
        <ChakraGrid
          position="sticky"
          top="25vh"
          textAlign="justify"
          height="50vh"
          gridAutoFlow="column"
          alignItems="center"
          pointerEvents="none"
          overflowX="hidden"
        >
          <Cells isScrolled={cellsInView} />
        </ChakraGrid>
        <Grid pb="2xl">
          <Box gridColumn="main">
            <Problem.Description />
          </Box>
        </Grid>

        <Box bg="red.300">
          <Grid pt="2xl" pb="50vh" color="white" position="relative" zIndex={2}>
            <Box gridColumn="main">
              <Solution.Title />
            </Box>
          </Grid>
        </Box>
      </Box>
      <Box bg="red.300" py="xs">
        <Grid color="white">
          <Box gridColumn="main" ref={cellsRef}>
            <Solution.Description />
          </Box>
        </Grid>
      </Box>
      <Grid
        py="2xl"
        bgColor="red.300"
        position="relative"
        zIndex={2}
        alignItems="end"
      >
        <Grid.Inner gridRowGap="xl">
          <Multiplier
            gridColumn={{ base: 'span 7', lg: 'span 4' }}
            width="100%"
            height="auto"
            color="gray.50"
            position="relative"
            top="1.65%"
          />
          <Flex
            gridColumn={{ base: 'span 12', lg: 'span 8' }}
            color="white"
            position="relative"
            flexDir="column"
            justifyContent="flex-end"
          >
            <Chart
              colorScheme="white"
              intersectionRef={chartRef}
              isScrolled={chartInView}
            />
          </Flex>
          <Button
            gridColumn="span 12"
            mt="3xl"
            as="a"
            href={data.solution.cta.href}
            variant="outline"
            colorScheme="white"
            isWide
            rightIcon={<ArrowRight />}
          >
            {data.solution.cta.title}
          </Button>
        </Grid.Inner>
      </Grid>
    </Box>
  );
};
